import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GuestProductAddToQuoteButton from "@WhiteCap/Components/GuestRFQ/GuestProductAddToQuoteButton";
import GuestProductQuantityOrdered from "@WhiteCap/Components/GuestRFQ/GuestProductQuantityOrdered";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
});

export interface GuestProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
}

export const actionsStyles: GuestProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
        `,
    },
    addToCartButton: {
        css: css`
            width: 100% !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 75%;
                        max-width: 75%;
                    `,
                    css`
                        flex-basis: 75%;
                        max-width: 75%;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 50%;
                [data-test-selector="product_qtyOrdered-label"] {
                    font-size: 15px;
                    font-weight: 600;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-basis: 25%;
                            max-width: 25%;
                        `,
                        css`
                            flex-basis: 25%;
                            max-width: 25%;
                        `,
                        css``,
                        css``,
                        css``,
                    ])}
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 20px;
            min-height: 2rem;
        `,
    },
};

const styles = actionsStyles;

const GuestProductDetailsActions = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    product: { id },
}: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.addToCartWrapper}>
                <GuestProductQuantityOrdered
                    configurationSelection={configurationSelection}
                    configurationCompleted={configurationCompleted}
                    variantSelectionCompleted={variantSelectionCompleted}
                    extendedStyles={styles.quantityOrdered}
                />
                <GuestProductAddToQuoteButton
                    configurationSelection={configurationSelection}
                    configurationCompleted={configurationCompleted}
                    variantSelectionCompleted={variantSelectionCompleted}
                    subscription={subscription}
                    data-test-selector={`actionsAddToQuote${id}`}
                    extendedStyles={styles.addToCartButton}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(GuestProductDetailsActions)),
    definition: {
        displayName: "Add to Quote Actions",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User